<template>
    <div class="o-debug-panel">
        Real Resolution: {{screenWidth}} x {{screenHeight}}<br/>
    </div>
</template>

<script>

export default {
    name: "ODebugPanel",
    data: () =>({

    }),
    methods: {

    },
    watch:{

    },
    computed:{
        screenWidth(){
            const w = window;
            return ( w.innerWidth < w.screen.width ) ? w.innerWidth : w.screen.width; // get proper width
        },
        screenHeight(){
            const w = window;
            return ( w.innerHeight < w.screen.height ) ? w.innerHeight : window.screen.height; // get proper width
        }

    },
    mounted() {
    },
    beforeDestroy() {
    },
}
</script>

<style lang="scss">
@import "theme";
</style>
